import { ExistingItemHandling } from '@scayle/storefront-nuxt'

export const usePromotionRemover = async () => {
  const basket = useAgsBasket()
  const log = useLog('usePromotionRemover')

  const run = async () => {
    const itemUpdates = (basket.data?.value?.items || []).reduce(
      (acc, item) => {
        const promo = item.promotion
        if (promo && (!promo.isActive || !promo.isValid)) {
          acc.push({
            variantId: item.variant.id,
            quantity: item.quantity,
            promotionId: null,
            customData: item.customData as any,
            displayData: item.displayData,
          })
        }
        return acc
      },
      [] as BasketItemUpdate[],
    )

    if (!itemUpdates.length) return

    log.debug('remove-promotions', {
      itemUpdates,
    })

    await basket.addItems(
      itemUpdates,
      ExistingItemHandling.REPLACE_EXISTING as any,
    )
  }

  watch(basket.data, run, { immediate: true })
}
